import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import * as c from "./actions.constants";
import * as s from "./load.status.constants.js";
import { DICT_REGION_NAME, DICT_AUTHOR_NAME } from "common/constants";

import cubaService from "common/api/cuba.reqs.service";
import { getValueByLocale, buildAuthorFio } from 'common/utils'

const initialStateCategories = {categories: [], status: s.EMPTY};
const initialStateRegions = {regions: [], status: s.EMPTY};
const initialStateDicts = {dicts: {}, status: s.EMPTY, counter: 0};

const fixRegion = (data, lang = 'ru') => {
    if (!data) return null;
    data.forEach(item => {
        if ( item.localizationFields && item.localizationFields.length > 0 ) {
            item.localizationFields[0].title = getValueByLocale(item, 'shortDescr',' en')
        }
        item.title = getValueByLocale(item, 'shortDescr', lang)
    });
    data.sort((a, b) => a.sortOrd - b.sortOrd);
    return data
};

const fixAuthor = (data, lang) => {
    if (!data) return null;
    data.forEach(item => {
        if ( item.localizationResearcherFields && item.localizationResearcherFields.length > 0 ) {
            item.localizationFields = [...item.localizationResearcherFields];
            item.localizationFields[0].title = buildAuthorFio(item,'en');
            delete item.localizationResearcherFields;
        }
        item.title = buildAuthorFio(item,lang);
    });
    return data;
};

const sortValues = (data, lang) => {
    if (!data) return null;
    data.sort((a, b) => {
        let aValue = getValueByLocale ( a, 'title', lang);
        let bValue = getValueByLocale ( b, 'title', lang);

        aValue.localeCompare(bValue, lang, {sensitivity: 'base'})
    });

    return data;
};

// First, create the thunk
export const fetchCategories = createAsyncThunk(c.LOAD_CATEGORIES,
    async () => {
        // const response = await cubaService.getAllItems('nkn$HeritageObjectCategoryDictionaryEntity');
        const response = await cubaService.getAllItemsByView('nkn$HeritageObjectCategoryDictionaryEntity', 'heritageObjectCategoryDictionaryEntityView');
        return response.data
    }
);

// First, create the thunk
export const fetchRegions = createAsyncThunk(c.LOAD_REGIONS,
    async (lang) => {
        const response = await Promise.allSettled([
            cubaService.getAllItemsByView(DICT_REGION_NAME, 'regionWithDistrictView'),
            cubaService.getAllItemsByView('nkn$DictFederalDistrictFieldsLocalization', 'dictFederalDistrictFieldsLocalizationView'),
            cubaService.getAllItemsByView('nkn$DictRegionFieldsLocalization', 'dictRegionFieldsLocalizationView'),
        ])

        const regions = response[0].value.data
        const regionsLoc = response[2].value.data;
        const districtsLoc = response[1].value.data;

        regions.forEach ( reg => {
            // link to parent
            reg.parentId = reg.federalDistrict.id || null;

            const regLoc = regionsLoc.find ( rl => rl.region.id === reg.id );
            // if ( regLoc && regLoc.region ) delete regLoc.region; // crushed
            reg.localizationFields = regLoc ? [regLoc] : [];

            const distrLoc = districtsLoc.find ( dl => dl.federalDistrict.id === reg.federalDistrict.id );
            // if ( distrLoc && distrLoc.federalDistrict ) delete distrLoc.federalDistrict; // crushed
            reg.federalDistrict.localizationFields = distrLoc ? [distrLoc] : [];
        })

        return Promise.resolve( fixRegion(regions, lang) );
    }
);

// First, create the thunk
export const fetchCustomDict = createAsyncThunk(c.LOAD_DICTS,
    async ({dictName, viewName, lang}) => {
        //const response = await cubaService.getAllItems(dictName);
        const response = await cubaService.getAllItemsByView(dictName, viewName);

        switch ( dictName ) {
            case DICT_REGION_NAME:
                throw new Error ('Use fetchRegion');
            case DICT_AUTHOR_NAME:
                return sortValues(fixAuthor(response.data, lang), lang);
            default:
                return sortValues(response.data, lang);
        }
    }
);

// Then, handle actions in your reducers:
export const catsSlice = createSlice({
    name: 'cats',
    initialState: initialStateCategories,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    /*
    extraReducers: (builder) => {
      builder
      .addCase(fetchCategories.fulfilled, (state, action) => {
        // Add categories to the state array
        state.categories.setTree(action.payload);
        state.status = state.status === s.EMPTY ? s.SUCCESS : state.status;
      })
      // and provide a default case if no other handlers matched
        .addDefaultCase((state, action) => {})
    }
    */
    extraReducers: {
        // Add reducers for additional action types here, and handle loading state as needed
        [fetchCategories.fulfilled]: (state, action) => {
            // Add user to the state array
            //state.categories.setTree(action.payload);
            state.categories = action.payload;
            state.status = s.SUCCESS;
        }
    }
});

// Then, handle actions in your reducers:
export const regsSlice = createSlice({
    name: 'regions',
    initialState: initialStateRegions,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    /*
    extraReducers: (builder) => {
      builder
      .addCase(fetchRegions.fulfilled, (state, action) => {
        // Add categories to the state array
        state.regions.setTree(action.payload);
        state.status = state.status === s.EMPTY ? s.SUCCESS : state.status;
      })
      // and provide a default case if no other handlers matched
        .addDefaultCase((state, action) => {})
    }
    */
    extraReducers: {
        // Add reducers for additional action types here, and handle loading state as needed
        [fetchRegions.fulfilled]: (state, action) => {
            // Add user to the state array
            //state.regions.setTree(action.payload);

            state.regions = action.payload;
            state.status = s.SUCCESS;
        }
    }
});

// Then, handle actions in your reducers:
export const dictsSlice = createSlice({
    name: 'dicts',
    initialState: initialStateDicts,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    /*
    extraReducers: (builder) => {
      builder
      .addCase(fetchRegions.fulfilled, (state, action) => {
        // Add categories to the state array
        state.regions.setTree(action.payload);
        state.status = state.status === s.EMPTY ? s.SUCCESS : state.status;
      })
      // and provide a default case if no other handlers matched
        .addDefaultCase((state, action) => {})
    }
    */
    extraReducers: {
        [fetchCustomDict.fulfilled]: (state, action) => {
            state.dicts[action.meta.arg.dictName] = action.payload;
            state.status = s.SUCCESS;
            state.counter = state.counter + 1;
        }
    }
});

export const catsSliceReducer = catsSlice.reducer;
export const regsSliceReducer = regsSlice.reducer;
export const dictsSliceReducer = dictsSlice.reducer;
